module.exports = __webpack_public_path__ + "static/media/gpsIcon.36284824.svg";